import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Upload, Globe, Building, Lock, Loader2 } from 'lucide-react';

const TAB_TYPE_OPTIONS = {
  'corporate-books': [{ value: 'minutes', label: 'Minutes' }, { value: 'resolution', label: 'Resolution' }, { value: 'certificate', label: 'Certificate' }],
  'meeting-docs': [{ value: 'notice', label: 'Notice' }, { value: 'attendance', label: 'Attendance' }, { value: 'proxy', label: 'Proxy' }],
  'governance': [],
  'regulatory': [{ value: 'filing', label: 'Reportorial Requirement' }],
  'communications': [{ value: 'letter', label: 'Letter' }, { value: 'memorandum', label: 'Memorandum' }],
  'other-resources': [{ value: 'law', label: 'Law / Rule / Regulation' }, { value: 'training', label: 'Training / Learning Material' }],
};

const GOV_CATEGORIES = [
  { key: 'credentials', label: 'Corporate Credentials' },
  { key: 'bylaws', label: 'By-Laws' },
  { key: 'strategy', label: 'Organizational Strategy' },
  { key: 'policies', label: 'Policies' },
  { key: 'processes', label: 'Office Processes' },
];

export const UploadDialog = ({ open, onOpenChange, uploadTab, uploadForm, setUploadForm, uploadFile, setUploadFile, onUpload, saving }) => {
  const typeOptions = uploadTab === 'governance' ? GOV_CATEGORIES : (TAB_TYPE_OPTIONS[uploadTab] || []);
  const isGov = uploadTab === 'governance';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Upload className="h-5 w-5 text-[#00A3A3]" />Upload to Library</DialogTitle></DialogHeader>
        <div className="space-y-4 py-2">
          {typeOptions.length > 0 && (
            <div><Label>{isGov ? 'Sub-Category' : 'Document Type'}</Label>
              <Select value={isGov ? uploadForm.gov_subcategory : uploadForm.record_type}
                onValueChange={v => isGov ? setUploadForm(f => ({ ...f, gov_subcategory: v })) : setUploadForm(f => ({ ...f, record_type: v }))}>
                <SelectTrigger className="border-[#E2E6EA] mt-1" data-testid="upload-type-select"><SelectValue placeholder="Select type..." /></SelectTrigger>
                <SelectContent>
                  {isGov ? GOV_CATEGORIES.map(c => (
                    <SelectItem key={c.key} value={c.key}>{c.label}</SelectItem>
                  )) : typeOptions.map(o => (
                    <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
          <div><Label>Title <span className="text-red-500">*</span></Label>
            <Input value={uploadForm.title} onChange={e => setUploadForm(f => ({ ...f, title: e.target.value }))} placeholder="Document title" className="mt-1 border-[#E2E6EA]" data-testid="upload-title-input" />
          </div>
          <div><Label>Classification</Label>
            <Select value={uploadForm.classification} onValueChange={v => setUploadForm(f => ({ ...f, classification: v }))}>
              <SelectTrigger className="border-[#E2E6EA] mt-1" data-testid="upload-classification-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="open"><div className="flex items-center gap-2"><Globe className="h-3.5 w-3.5 text-green-600" />Open / Public</div></SelectItem>
                <SelectItem value="internal"><div className="flex items-center gap-2"><Building className="h-3.5 w-3.5 text-blue-600" />Internal</div></SelectItem>
                <SelectItem value="classified"><div className="flex items-center gap-2"><Lock className="h-3.5 w-3.5 text-red-600" />Classified</div></SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label>Description</Label>
            <Textarea value={uploadForm.description} onChange={e => setUploadForm(f => ({ ...f, description: e.target.value }))} placeholder="Brief description..." rows={3} className="mt-1 border-[#E2E6EA]" data-testid="upload-desc-input" />
          </div>
          <div><Label>File Attachment</Label>
            <Input type="file" onChange={e => setUploadFile(e.target.files?.[0] || null)} className="mt-1 border-[#E2E6EA]" data-testid="upload-file-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onUpload} disabled={saving || !uploadForm.title.trim()} className="bg-[#00A3A3] hover:bg-[#008585]" data-testid="confirm-upload-btn">
            {saving && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Upload
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
